import { observer } from 'mobx-react-lite';

import { ImagePlaceholder } from '@gem/components';

import usePresenter from './presenter';

// this payload needs only for client
const LoadImageByLink = ({ parentPresenter, payload, order, id }) => {
  const presenter = usePresenter({ parentPresenter, payload, order, id });

  return (
    <ImagePlaceholder
      width={presenter.width}
      height={presenter.height}
    />
  );
};

export default observer(LoadImageByLink);
